<template>
  <Tabs v-model="tabName" :animated="false" class="tabs_styles">
    <TabPane :label="$t('key1001587')" name="selfOwnedLogistics">
      <selfOwnedLogisticsList v-if="tabName === 'selfOwnedLogistics'"></selfOwnedLogisticsList>
    </TabPane>
    <TabPane :label="$t('key1002349')" name="thirdPartyLogistics">
      <thirdPartyLogisticsList v-if="tabName === 'thirdPartyLogistics'"></thirdPartyLogisticsList>
    </TabPane>
  </Tabs>
</template>

<script>
import selfOwnedLogisticsList from "@/views/supplier/components/warehouseLogistics/selfOwnedLogisticsList.vue";
import thirdPartyLogisticsList from "@/views/supplier/components/warehouseLogistics/thirdPartyLogisticsList.vue";

export default {
  name: 'supplierLogisticsManage',
  data() {
    return {
      tabName: 'selfOwnedLogistics',
    };
  },
  components: {
    selfOwnedLogisticsList,
    thirdPartyLogisticsList
  }
};
</script>

<style lang="less" scoped>

</style>
